<div class="modal-card">
  <div class="icon-circle">
    <img src="assets/icons/del-info-icon.svg" alt="info">
  </div>
  <h2 class="title">Delete Chat</h2>
  <p class="desc">
    Are you sure you want to delete this chat?
  </p>
  <div class="actions">
    <button class="btn btn-cancel" (click)="onCancel()">Cancel</button>
    <button class="btn btn-delete" (click)="onDelete()">Delete</button>
  </div>
</div>
